import { render, staticRenderFns } from "./PluginLinkedinPixel.vue?vue&type=template&id=48ede5ca"
import script from "./PluginLinkedinPixel.vue?vue&type=script&lang=js"
export * from "./PluginLinkedinPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ede5ca')) {
      api.createRecord('48ede5ca', component.options)
    } else {
      api.reload('48ede5ca', component.options)
    }
    module.hot.accept("./PluginLinkedinPixel.vue?vue&type=template&id=48ede5ca", function () {
      api.rerender('48ede5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginLinkedinPixel.vue"
export default component.exports